import { HistoryAction, HistoryActionTranslations } from '@/enums/historyAction.enum';
import { HistoryLog } from '@/interfaces/historyLog';

/**
 * Tłumaczy akcję historii
 *
 * @export
 * @param {HistoryAction} action
 * @returns {string}
 */
export function historyAction(log: HistoryLog): string {
  const changes = log.json && log.changes && JSON.parse(log.changes);
  if (changes?.before?.statusId) {
    return HistoryActionTranslations[HistoryAction.SET_STATUS];
  }
  return HistoryActionTranslations[log.action] || 'Nieznana akcja';
}
